import { Typography } from "@circleco/compass/components/Typography";

import type { AvatarProps } from "@/react/components/Modals/MessagingModalCompass/LeftSidebar/List/Item/Avatar";
import { Avatar } from "@/react/components/Modals/MessagingModalCompass/LeftSidebar/List/Item/Avatar";
import type { BodyProps } from "@/react/components/Modals/MessagingModalCompass/LeftSidebar/List/Item/Body";
import { Body } from "@/react/components/Modals/MessagingModalCompass/LeftSidebar/List/Item/Body";
import { RightSideIndicators } from "@/react/components/Modals/MessagingModalCompass/LeftSidebar/List/Item/RightSideIndicators";

export interface ItemProps extends AvatarProps, BodyProps {
  chatRoomName: string;
  currentParticipant: {
    id?: number;
    name?: string;
    avatarUrl?: string;
    muted?: boolean;
  };
  hasUnreadMessages: boolean;
  isPinned?: boolean;
  timestamp: string;
}

export const Item = ({
  isDirect,
  otherParticipants,
  chatRoomName,
  timestamp,
  lastMessage,
  currentParticipant,
  hasUnreadMessages,
  currentCommunityMember,
  isPinned = false,
}: ItemProps) => (
  <div
    className="flex w-full items-center gap-3"
    data-testid="direct-message-details"
  >
    <Avatar isDirect={isDirect} otherParticipants={otherParticipants} />
    <div className="flex flex-col min-w-0 flex-1">
      <div className="flex items-center justify-between gap-2">
        <Typography
          variant="heading-sm"
          color="primary"
          truncate
          className="min-w-0"
        >
          {chatRoomName}
        </Typography>
        <RightSideIndicators
          isPinned={isPinned}
          currentParticipant={currentParticipant}
          hasUnreadMessages={hasUnreadMessages}
          className="min-w-fit justify-center"
        />
      </div>
      <div className="flex items-center justify-between w-full gap-2">
        <Body
          isDirect={isDirect}
          lastMessage={lastMessage}
          currentCommunityMember={currentCommunityMember}
        />
        <Typography variant="caption" color="tertiary" className="shrink-0">
          {timestamp}
        </Typography>
      </div>
    </div>
  </div>
);
